import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/header-banner.jpg';
import prosoectus from '../assests/img/prosoectus.pdf';
import syllabus from '../assests/img/Syl.pdf';
import regulations from '../assests/img/regulations.pdf';
import { Helmet } from 'react-helmet-async';


function Download() {
  return (
    <div >
      <Helmet>
        <title>Download | State Board of Secondary Education, Delhi</title>
        <meta
          name="description"
          content="Learn more about Download | State Board of Secondary Education, Delhi, and its initiatives to promote education and literacy."
        />
        <meta
          name="keywords"
          content="State Board of Secondary Education, Delhi, education, literacy, initiatives"
        />
      </Helmet>

      <Header />
      {/* <Showlist/> */}
      <div className='container'>
        <div className='about-banner'>
          <img src={aboutBanner} alt="" />
          <h1 className='page-title'>Downloads</h1>
        </div>
      </div>

      <div className='container main-contant'>
        <div className='inner-page-container skill-education-container'>
          <div className="content-secion">
            <table className="download-table table">
              <tbody>
                <tr>
                  <td>
                    <h4>SBSE’s Prosoectus</h4>
                  </td>
                  <td><a className="btn btn-link" href={prosoectus}>Download</a></td>
                </tr>
                <tr>
                  <td>
                    <h4>SBSE’s Syllabus</h4>
                  </td>
                  <td><a className="btn btn-link" href={syllabus}>Download</a></td>
                </tr>
                <tr>
                  <td>
                    <h4>SBSE’s Regulations</h4>
                  </td>
                  <td><a className="btn btn-link" href={regulations}>Download</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  )
}

export default Download;
